export {default} from './AllFrontlineClientsReport';
